// Error boundary around the lazy simulator views: a crash in the Sandbox
// or Search drops back to a retry card instead of blanking the whole page.
import { Component } from 'react';
import './Simulator.css';

export default class SimulatorErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { label, onReset, children } = this.props;
    if (!error) return children;
    return (
      <div className="sim-error" role="alert">
        <h3>{label || 'Simulator'} hit a problem</h3>
        <p>{error.message || 'Something went wrong while rendering this view.'}</p>
        <button
          type="button"
          onClick={() => {
            this.setState({ error: null });
            if (onReset) onReset();
          }}
        >
          Try again
        </button>
      </div>
    );
  }
}
